import type { ContentItem, Reference } from '@ps/web-martech-cms-types';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

const useCMSReference = <T extends ContentItem>(reference?: Reference) =>
  useSelector(
    (rootState: RootState) =>
      select.cms.getContentItem(rootState, reference?.uid ?? '') as T | undefined
  );

export default useCMSReference;
